export default __webpack_public_path__ + "static/media/logo1.9806f87d.svg";